import React, { useEffect } from 'react';
import Button from 'react-bootstrap/Button';
import Spinner from 'react-bootstrap/Spinner';
import Alert from 'react-bootstrap/Alert';
import { useDispatch, useSelector } from 'react-redux';
import { fetchSerialNumber } from 'software_renewal/redux/thunks';
import { selectLoading, selectSerialNumber, selectAddingToCart, selectMultipleProductsError } from 'software_renewal/redux/selectors';
import { clearMultipleProductsError, setSerialNumber, toggleForgotSerialNumberModal } from 'software_renewal/redux/slice';
import ForgotSerialNumberModal from 'software_renewal/components/ForgotSerialNumberModal';

const LicenseSearch = () => {
  const dispatch = useDispatch();
  const loading = useSelector(selectLoading);
  const serial = useSelector(selectSerialNumber);
  const addingToCart = useSelector(selectAddingToCart);
  const multipleProductsError = useSelector(selectMultipleProductsError);

  const onClick = (serialNumber = null) => {
    const query = serialNumber || serial;
    if (!query || !query.trim()) return;
    dispatch(fetchSerialNumber(query));
  };

  const onForgotSerialNumber = () => {
    dispatch(toggleForgotSerialNumberModal(true));
  };

  useEffect(() => {
    if (Spree?.serial && Spree.serial.length) {
      dispatch(setSerialNumber(Spree?.serial));
      onClick(Spree?.serial);
    }
  }, []);

  return (
    <div className="license-search">
      <label
        className="label-serial w-100"
        htmlFor="serial"
      >
        Enter the serial number
        <div className="d-flex gap-2 mb-2">
          <input
            id="serial"
            disabled={loading}
            name="serial"
            value={serial}
            onChange={(e) => {
              dispatch(setSerialNumber(e.target.value));
              if (multipleProductsError) {
                dispatch(clearMultipleProductsError());
              }
            }}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                e.preventDefault();
                onClick();
              }
            }}
            type="text"
            className="form-control form-control-lg w-100"
          />
          <Button
            variant="primary"
            onClick={() => onClick(serial)}
            disabled={loading || addingToCart}
            className="btn-renew-now text-nowrap ml-2"
          >
            {loading && (
              <Spinner
                as="span"
                animation="border"
                size="sm"
                className="mr-2"
              />
            )}
            Renew Now
          </Button>
        </div>
        {multipleProductsError && (
          <div className="error-container mt-2">
            <Alert variant="danger" className="mb-0">
              {multipleProductsError}
            </Alert>
          </div>
        )}
      </label>
      <Button
        variant="link"
        className="px-0"
        disabled={loading}
        onClick={onForgotSerialNumber}
      >
        Forgot serial number?
      </Button>
      <ForgotSerialNumberModal />
    </div>
  );
};

export default LicenseSearch;
